import { applyMiddleware, combineReducers, createStore as __createStore, Middleware, Store as __Store } from 'redux';
import State from './state';

// import reducers
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import currentSession from '../state/currentSession';
import currentStore from '../state/currentStore';
import currentUser from '../state/currentUser';

import contentSelect from '../state/contentSelect';
import cart from '../state/cart';
import payment from '../state/payment';
import confirm from '../state/confirm';

import signup from '../state/signup';
import editUser from '../state/editUser';
import buyProduct from '../state/buyProduct';

export type Store = __Store<State>;

const createStore = (initialState: Partial<State> = {}, middlewares: Middleware[] = []): Store => {
  const combinedReducer = combineReducers({
    currentStore,
    currentUser,
    currentSession,
    contentSelect,
    cart,
    payment,
    confirm,
    signup,
    editUser,
    buyProduct,
  });

  return __createStore(combinedReducer, initialState, composeWithDevTools({})(applyMiddleware(...middlewares)));
};

export default createStore;
